import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Riverine_Flooding/FeatureServer/1&source=sd)
 *  */
const HURRICANE_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.029,
  colors.amber[300],
  0.071,
  colors.orange[500],
  0.129,
  colors.red[500],
  0.217,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Riverine_Flooding/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 0.217 – 0.44", 11],
    ["> 0.129 – 0.217", 9],
    ["> 0.071 – 0.129", 7],
    ["> 0.029 – 0.071", 5],
    ["0 – 0.029", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: HURRICANE_STOPS[row[1] as number],
  }));
};

export const hurricanes = {
  stops: HURRICANE_STOPS,
  props: getLegendRows(),
};
